module.exports = __webpack_public_path__ + "static/media/play-icon-blue.1bf0a446.svg";